import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ffe063",
      "fill-rule": "evenodd",
      d: "M2.9 4.9c-.5 0-.9.4-.9.9v12.8c0 .5.4 1 .9 1H21c.5 0 .9-.5.9-1V5.8c0-.5-.4-1-.9-1H3Zm6.4 1.3H4v1.3h5.3z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4a4a4a",
      "fill-rule": "evenodd",
      d: "M2 8.9h20v2.6H2V9Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fe2851",
      "fill-rule": "evenodd",
      d: "M4 15.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#537499",
      "fill-rule": "evenodd",
      d: "M7.3 15.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }